import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider as MaterialThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@playsistemico/modo-ui-portal-lib';

import { modoTheme } from './global/theme';
import { Auth0ProviderWithNavigate } from './auth0-provider-with-navigate';
import App from './app';
import store from './redux/store';
import { registerBfcacheReload } from './utils/bfcache';

import 'animate.css';

registerBfcacheReload();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}
const root = createRoot(container);

root.render(
  <ThemeProvider>
    <MaterialThemeProvider theme={modoTheme}>
      <CssBaseline />
      <BrowserRouter>
        <Provider store={store}>
          <Auth0ProviderWithNavigate>
            <App />
          </Auth0ProviderWithNavigate>
        </Provider>
      </BrowserRouter>
    </MaterialThemeProvider>
  </ThemeProvider>
);
